import { type ElementType, type ReactNode } from 'react'

import { typography, type TypographyVariant } from './variants'

type LabelVariant =
  | 'sectionLabel'
  | 'sectionLabelMuted'
  | 'overline'
  | 'designation'
  | 'cta'
  | 'nav'

export interface LabelProps {
  as?: ElementType
  variant?: LabelVariant
  children: ReactNode
  className?: string
}

const variantToDefaultTag: Record<LabelVariant, ElementType> = {
  sectionLabel: 'p',
  sectionLabelMuted: 'p',
  overline: 'span',
  designation: 'p',
  cta: 'span',
  nav: 'span',
}

export function Label({ as, variant = 'sectionLabel', children, className = '' }: LabelProps) {
  const Tag = as ?? variantToDefaultTag[variant]
  const baseClasses = typography[variant as TypographyVariant]
  const classes = [baseClasses, className].filter(Boolean).join(' ')
  return <Tag className={classes}>{children}</Tag>
}
